<template>
	<GlassCard class="restaurant-calendar p-2">
		<h2 class="p-3">Monthly Restaurant</h2>
		<vue-cal
			hide-view-selector
			@view-change="fetchEventsForMonth"
			@cell-click="fetchForDate"
			:disable-views="['years', 'year', 'week', 'day']"
			default-view="month"
			active-view="month"
			:events="events"
			:startWeekOnSunday="true"
			style="height: 350px" />
		<div class="meal-details mt-3 container">
			<h5>Showing {{ formatToDay(selectedDate) }}</h5>
			<food-swiper :meals="meals" />
		</div>
	</GlassCard>
</template>

<script setup>
	import { ref, onMounted, watch, onBeforeMount, onBeforeUnmount } from "vue"
	import GlassCard from "./GlassCard.vue"
	import VueCal from "vue-cal"
	import moment from "moment-timezone"
	import FoodSwiper from "@/components/FoodSwiper.vue"
	// import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import { isOnline } from "@/utils/networkBus"

	// const props = defineProps({ user: Object })

	const meals = ref([])
	const events = ref([])
	const selectedDate = ref("")

	// const router = useRouter()
	// const tokenStore = useTokenStore()

	const fetchEventsForMonth = async (event) => {
		if (!isOnline.value) return
		//get month/year from start date
		const date = moment(event.startDate)
		//now fetch the events
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth(
				`/api/report/restaurants-by-date/${moment(date).unix()}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			if (!response.ok) throw new Error("Failed to fetch data")
			const data = await response.json()
			// for (const d of data) {
			// 	d.start = moment.unix(d.timestamp).format("YYYY-MM-DD")
			// 	d.end = moment.unix(d.timestamp).format("YYYY-MM-DD")
			// }
			events.value = data
			// console.log(meals.value)
			// }
		} catch (error) {
			console.error("Error:", error)
		}
	}

	function formatToDay(timestamp) {
		return timestamp ? moment(timestamp).format("MM/DD/YYYY") : ""
	}

	const fetchForDate = async (date) => {
		selectedDate.value = date
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth(
				`/api/restaurants-by-date/${moment(date).unix()}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			if (!response.ok) throw new Error("Failed to fetch data")
			meals.value = await response.json()
			// console.log(meals.value)
			// }
		} catch (error) {
			console.error("Error:", error)
		}
	}

	onMounted(() => {
		fetchEventsForMonth({ startDate: moment().toDate() })
		fetchForDate(moment().toDate()) // Fetch meals for today on component mount
	})

	// watch(lastMealUpdated, (v) => {
	// 	if (!v) return
	// 	//check to see if the new one that updated is our id and if it is, updated it
	// 	const index = meals.value.findIndex((a) => a.id === v.id)
	// 	if (index > -1) {
	// 		meals.value[index] = v
	// 	}
	// })

	// watch(lastMealDeleted, (v) => {
	// 	if (!v) return
	// 	//check to see if the new one that updated is our id and if it is, updated it
	// 	const index = meals.value.findIndex((a) => a.id === v.id)
	// 	if (index > -1) {
	// 		meals.value.splice(index, 1)
	// 	}

	// 	const eventIndex = events.value.findIndex((a) => a.id === v.id)
	// 	if (eventIndex > -1) {
	// 		events.value.splice(eventIndex, 1)
	// 	}
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", (meal) => {
			if (!meal) return
			const index = meals.value.findIndex((a) => a.id === meal.id)
			if (index > -1) {
				meals.value[index] = meal
			}
		})

		offMealDeleted = EventBus.on("meal-deleted", (meal) => {
			if (!meal) return
			const index = meals.value.findIndex((a) => a.id === meal.id)
			if (index > -1) {
				meals.value.splice(index, 1)
			}

			const eventIndex = events.value.findIndex((a) => a.id === meal.id)
			if (eventIndex > -1) {
				events.value.splice(eventIndex, 1)
			}
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})
</script>

<style lang="less" scoped>
	.restaurant-calendar {
		/* Allow the glass-card to handle background; add spacing tweaks */
		border-radius: 12px;
	}
</style>
